import React, { FC } from "react";

import {
  modalCancel,
  modalPrimary,
  PortalModal,
} from "../clientPortal/PortalModal";
import { markAllDoneQuestion } from "./notifications.utils";

/** Confirm before "Mark all as done" (page and bell drop-down). */
export const MarkAllDoneConfirm: FC<{
  count: number | null;
  label?: string;
  /** Unread among them (whole inbox only). */
  unread?: number | null;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ count, label, unread, onCancel, onConfirm }) => (
  <PortalModal
    title={markAllDoneQuestion(count, label, unread)}
    onClose={onCancel}
    width={440}
    footer={
      <>
        <button type={"button"} className={modalCancel} onClick={onCancel}>
          Cancel
        </button>
        <button type={"button"} className={modalPrimary} onClick={onConfirm}>
          Move to Done
        </button>
      </>
    }>
    <p className={"m-0 text-[14px] text-[#4A5163]"}>
      They leave your inbox but stay unread or read as they are now. You can
      find them under Done, and Undo right after brings them all back.
    </p>
  </PortalModal>
);
